module.exports = __webpack_public_path__ + "static/img/1-yuan-icon.648da1e5.png";